import React, { useState, useEffect } from "react";
import Hourglass from "./images/webp/Hourglass_White_2.webp";
import HourglassBG from "./images/webp/Hourglass_White_1.webp";
import Lightbulb from "./images/webp/Lightbulb_White_2.webp";
import LightbulbBG from "./images/webp/Lightbulb_White_1.webp";
import Money1 from "./images/webp/Money_White_2.webp";
import Money2 from "./images/webp/Money_White_3.webp";
import Money3 from "./images/webp/Money_White_4.webp";
import MoneyBG from "./images/webp/Money_White_1.webp";
import Gears1 from "./images/webp/Gears_White_2.webp";
import Gears2 from "./images/webp/Gears_White_3.webp";
import GearsBG from "./images/webp/Gears_White_1.webp";
import { Parallax } from 'react-scroll-parallax';


const animations = {
    hourglass: {
        images: [
            {
                src: Hourglass,
                translateY:[-20, 5],
            }
        ],
        bgImage: HourglassBG,
    },
    lightbulb: {
        images: [
            {
                src: Lightbulb,
                translateY:[-20, 10],
            }
        ],
        bgImage: LightbulbBG,
    },
    money: {
        images: [
            {
                src: Money1,
                translateY:[-15, 0 ],
            },
            {
                src: Money2,
                translateY:[-25, 10],
            },
            {
                src: Money3,
                translateY:[-35,  10],
            }
        ], 
        bgImage: MoneyBG,
    },
    gears: {
        images: [
            {
                src: Gears1,
                translateY:[-20, 5],
            },
            {
                src: Gears2,
                translateY:[-30, 15],
            }
        ],
        bgImage: GearsBG,
    }
}



export default function AboutAnimation({ animationName }) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Adjust translateY end values for mobile so objects come down more and settle on pedestal
    const getTranslateY = (originalTranslateY) => {
        if (isMobile) {
            // Increase end value (second number) by 20 for all animations on mobile
            return [originalTranslateY[0], originalTranslateY[1] + 20];
        }
        // Keep original values for desktop
        return originalTranslateY;
    };
    
    return (
        <div className={`flex flex-col items-center mx-auto bg-no-repeat bg-center bg-[length:300px] md:bg-[length:100%] w-full md:w-1/2 md:max-w-[430px] max-h-full absolute md:relative top-0 z-0 h-[70vh] lg:h-[600px]`} style={{backgroundImage: `url(${animations[animationName].bgImage})`}}>
            {animations[animationName].images.map((image, index) => {
                return (
                    <Parallax key={index} easing='easeOutQuad' translateY={getTranslateY(image.translateY)} className="absolute top-4 z-10">
                        <img src={image.src} alt="" loading="lazy" decoding="async" width="450" height="450" className="mx-auto max-w-[350px] lg:max-w-[450px] md:mx-w-[auto]" />
                    </Parallax>
                );
            })}
        </div>
    )
}